// extracted by mini-css-extract-plugin
export default {"container":"cYgKa4XKvENzWAg","revoking-signature-button":"yD9b6RIrsj2cBSc","inline":"L1bCfdURMNNoT3M"};